import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Popconfirm, Space, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { useKickMessage, useUpdateKickMessage, useDeleteKickMessage } from './useKickMessageManager';

const KickMessageManager = () => {
    const { data: messages = [], isLoading, refetch } = useKickMessage();
    const updateMutation = useUpdateKickMessage();
    const deleteMutation = useDeleteKickMessage();

    const [modalOpen, setModalOpen] = useState(false);
    const [editing, setEditing] = useState(null); // {index, memo}
    const [form] = Form.useForm();

    // 테이블 컬럼
    const columns = [
        { title: 'Index', dataIndex: 'index', key: 'index', width: 100 },
        { title: '메모', dataIndex: 'memo', key: 'memo', width: 300 },
        { title: '수정일', dataIndex: 'updated', key: 'updated', width: 180 },
        {
            title: '액션',
            key: 'action',
            width: 160,
            render: (_, record) => (
                <Space>
                    <Button icon={<EditOutlined />} size="small" onClick={() => onEdit(record)}>
                        수정
                    </Button>
                    <Popconfirm
                        title="정말 삭제하시겠습니까?"
                        onConfirm={() => handleDelete(record.index)}
                        okText="삭제"
                        cancelText="취소"
                    >
                        <Button icon={<DeleteOutlined />} size="small" danger>
                            삭제
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // 수정/추가 모달 열기
    const onEdit = (record) => {
        setEditing(record);
        form.setFieldsValue({ index: record.index, memo: record.memo });
        setModalOpen(true);
    };
    const onAdd = () => {
        setEditing(null);
        form.resetFields();
        setModalOpen(true);
    };
    // 저장(추가/수정) - 서버에 바로 저장
    const handleOk = () => {
        form.validateFields().then((values) => {
            let nextMessages = {...values };

            updateMutation.mutate(nextMessages, {
                onSuccess: () => {
                    message.success('저장 완료');
                    setModalOpen(false);
                    refetch();
                },
                onError: () => message.error('저장 실패'),
            });
        });
    };
    // 삭제(서버에 바로 반영)
    const handleDelete = (index) => {
        deleteMutation.mutate(index, {
            onSuccess: () => {
                message.success('삭제 완료');
                refetch();
            },
            onError: () => message.error('삭제 실패'),
        });
    };
    // 서버 새로고침
    const handleReload = () => {
        refetch();
    };

    return (
        <div>
            <Space style={{ marginBottom: 16 }}>
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    메시지 추가
                </Button>
                <Button icon={<ReloadOutlined />} onClick={handleReload} disabled={isLoading}>
                    새로고침
                </Button>
            </Space>
            <Table
                dataSource={messages}
                columns={columns}
                rowKey="index"
                loading={isLoading}
                pagination={false}
                size="middle"
            />
            <Modal
                title={editing ? '메시지 수정' : '메시지 추가'}
                open={modalOpen}
                onOk={handleOk}
                onCancel={() => setModalOpen(false)}
                destroyOnClose
            >
                <Form form={form} layout="vertical" initialValues={{ memo: '' }}>
                    <Form.Item
                        label="Index"
                        name="index"
                        rules={[{ required: true, message: 'index를 입력하세요' }]}
                    >
                        <Input type="number" disabled={!!editing} />
                    </Form.Item>
                    <Form.Item
                        label="메시지 내용 (누구나 알기 쉽고 간략하게)"
                        name="memo"
                        rules={[{ required: true, message: '메시지를 입력하세요' }]}
                    >
                        <Input maxLength={100} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default KickMessageManager;